export const API_URL = "https://picknickapi2.herokuapp.com/api/";
export const API_TOKEN = "209a2d94-3880-47ac-b1a8-409c614cfa6a";
//export const API_URL = "http://localhost:8585/api/";
//export const API_TOKEN = "1e1ec27f-61d7-49ef-aec5-fc7ba3490768";